<div class="panel panel-default" *ngIf="authService.isGestorIndividual()">
  <div class="panel-body">

    <ng-container *ngIf="!currentUser.pessoaLogada">
      <div class="form-group">
        <label for="doc-simulator">Informe o documento cadastrado da Pessoa</label>
        <div class="input-group">
          <input #docInput
                 id="doc-simulator"
                 required
                 class="form-control"
                 type="text"
                 placeholder="Digite o documento e pressione Enter ou clique em Buscar"
                 (keyup.enter)="obterDadosPessoa(docInput.value)"/>
          <button class="btn btn-primary" type="button" (click)="obterDadosPessoa(docInput.value)">
            <em class="glyphicon glyphicon-search"></em> Buscar
          </button>
        </div>
      </div>

      <div class="found-person" *ngIf="pessoaSimulator">
        <div class="found-person__info">
          <div><strong><em class="glyphicon glyphicon-user"></em> Nome:</strong> {{ pessoaSimulator?.nome }}</div>
          <div><strong><em class="glyphicon glyphicon-globe"></em> Nacionalidade:</strong> {{ pessoaSimulator?.nacionalidade?.nome }}</div>
        </div>
        <button class="btn btn-success btn-block" type="button" (click)="simularAcesso();">
          <em class="glyphicon glyphicon-user"></em> Simular acesso
        </button>
      </div>
    </ng-container>

    <div *ngIf="currentUser.pessoaLogada">
      <button class="btn btn-danger btn-block" type="button" (click)="removerAcessoSimulado();">
        <em class="glyphicon glyphicon-user"></em> Retornar meu perfil
      </button>
    </div>

  </div>
</div>
